export default __webpack_public_path__ + "static/media/vp_install.43c3dc2e.png";